/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// If navigator.clipboard doesn't work, fallback is to create a dummy textarea,

import openConsoleAlertMessage from '../../misc/openConsoleAlertMessage';
import i18n from 'i18next';

// copy the contents and use this text
const fallbackCopyTextToClipboard = (text) => {
  var textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    var success = document.execCommand('copy');
    document.body.removeChild(textArea);

    if (success) {
      // Copying to clipboard was successful!
      openConsoleAlertMessage({ type: 'success', message: i18n.t('Copied to clipboard!') });
    } else {
      // Could not copy text
      openConsoleAlertMessage({ type: 'error', message: i18n.t('Could not copy text.') });
    }
  } catch (err) {
    // Could not copy text
    openConsoleAlertMessage({ type: 'error', message: i18n.t('Could not copy text.') });
  }
};
/**
 *
 *
 * @export
 * @param {String} text //String to be copied
 * @param {string} [successMessage='Copied to clipboard!'] //Message to be shown if the copy is succesfull, it has default message
 * @param {string} [errorMessage='Could not copy text.'] //Message to be shown if copy is not succesfull, it has default message
 * @return {Function} // Returns a fallback function only if something goes wrong with the clipboard
 */
export const copyTextToClipboard = (text, successMessage = 'Copied to clipboard!', errorMessage = 'Could not copy text.') => {
  if (!navigator.clipboard) {
    return fallbackCopyTextToClipboard(text);
  }

  navigator.clipboard.writeText(text).then(function () {
    // Copying to clipboard was successful!
    openConsoleAlertMessage({ type: 'success', message: successMessage });
  }, function (err) {
    // Could not copy text
    openConsoleAlertMessage({ type: 'error', message: errorMessage });
  });
};
